import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ContactService } from './contact.service';

import { Contact } from './contact.interface';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  contact: FormGroup;
  isSubmitted: boolean = false;
  isSent: boolean = false;
  isTrying: boolean = false;

  constructor(
    private fb: FormBuilder,
    private _contact: ContactService
  ) {}

  ngOnInit() {
    this.contact = this.fb.group({
      name: ['', Validators.required],
      email_from: ['', Validators.required],
      message: ['', Validators.required]
    });
  }

  onSubmit({value, valid}: {value: Contact, valid: boolean}) {
    if (!valid) {
      this.isSubmitted = true;
    } else {
      this.isTrying = true;
    }
    value.email_to = 'contacto@nanopharmacia.com';
    value.subject = 'Nuevo contacto de la página de Nanopharmacia.';
    this._contact.getInTouch(value).then((response) => {
      this.contact.reset();
      this.isSent = true;
    }).catch(error => console.log(error));
  } 

}



// WEBPACK FOOTER //
// ./src/app/contact/contact.component.ts